import * as yup from 'yup';
import { CreateSearchFormData } from '../CreateSearchSchema';

function getQuestionWithError(
  questions: CreateSearchFormData['post_questions']
): number[] {
  const questionsWithErrors = [];
  for (let i = 0; i < questions.length; i++) {
    if (!questions[i].value && questions[i + 1]?.value) {
      questionsWithErrors.push(i);
    }
  }
  return questionsWithErrors;
}

export const QuestionsStepSchema = yup.object().shape({
  post_questions: yup.array().of(
    yup
      .object()
      .shape({
        value: yup.string(),
      })
      .test('post_questions', `Required`, (_, context) => {
        const indexErrors = getQuestionWithError(context.parent);
        for (const idx of indexErrors) {
          if (context.path.includes(String(idx))) {
            return false;
          }
        }
        return true;
      })
  ),
});
